/**
 * Password recovery flow state (sessionStorage).
 *
 * After recovery OTP verification Supabase creates a full session.
 * We must not treat the user as "logged in" until the new password is set.
 */

const STORAGE_KEY = 'leadsme:password_recovery_email';

export function setPasswordRecoveryPending(email: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, email.trim());
  } catch {
    // ignore
  }
}

export function getPasswordRecoveryEmail(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function isPasswordRecoveryPending(): boolean {
  return !!getPasswordRecoveryEmail();
}

export function clearPasswordRecoveryPending(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}
